/**
 * Converts string representation of boolean value to a corresponded Boolean type value.
 *
 * @param {*} str
 * @returns {boolean}
 */
export default (str) => {
    const string = (typeof str === 'string') ? str.toLowerCase().trim() : str;
    switch (string) {
        case 'true':
        case 'yes':
        case '1':
            return true
        case 'false':
        case 'no':
        case '0':
        case null:
            return false
        default: return Boolean(string)
    }
}
